<template>
  <div class="content">
    <modal :show.sync="shouldShow" @hidden="onClickCancel" v-on:close="onClickCancel" footerClasses="justify-content-center" type="notice">
      <div class="row">
        <div class="col-sm-6">
          <h4 slot="header" class="modal-title">
            <b>신고자 발송 메시지</b>
          </h4>

          <div class="row">
            <div class="col-md-12 checkbox-radios">
              <base-radio
                class="radio-button col-md-12"
                v-for="(message, index) in messages"
                v-bind:name="index"
                v-bind:key="index"
                v-bind:message="message"
                v-model="selectedMessageToReporterIndex"
                >{{ message }}</base-radio
              >
              <base-radio name="-1" v-model="selectedMessageToReporterIndex">보내지 않음</base-radio>
            </div>
          </div>
        </div>
        <div class="col-sm-6" v-if="mode === 'approval' && namespace !== 300">
          <h4 slot="header" class="modal-title">
            <b>컨텐츠 작성자 발송 메시지</b>
          </h4>

          <div class="row">
            <div class="col-md-12 checkbox-radios">
              <base-radio
                class="radio-button col-md-12"
                v-for="(message, index) in messages"
                v-bind:name="index"
                v-bind:key="index"
                v-bind:message="message"
                v-model="selectedMessageToWriterIndex"
                >{{ message }}</base-radio
              >
              <base-radio name="-1" v-model="selectedMessageToWriterIndex">보내지 않음</base-radio>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="justify-content-center">
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickConfirm">확인</base-button>
        <base-button class="footer-buttons col-6" type="danger" round @click.native="onClickCancel">취소</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import { Modal } from "@/components/index";
import BaseButton from "@/components/BaseButton";
import { BlipNamespace } from "@/common/BlipNamespace";

export default {
  name: "ReportNotificationModal",
  components: {
    BaseButton,
    Modal,
  },
  data() {
    return {
      selectedMessageToReporterIndex: -1,
      selectedMessageToWriterIndex: -1,
    };
  },
  created() {
    window.addEventListener("keydown", this.onPressEnter);
  },
  props: {
    shouldShow: {
      type: Boolean,
      required: true,
    },
    namespace: {
      type: Number,
    },
    mode: {
      type: String,
    },
    messages: {
      type: Array,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onPressEnter);
  },
  methods: {
    async onPressEnter(e) {
      if (this.shouldShow && e.key === "Enter") {
        await this.onConfirm(this.selectedMessageToReporterIndex === 0, this.selectedMessageToWriterIndex === 0);
        this.shouldShow = false;
      }
    },
    onClickConfirm: async function () {
      await this.onConfirm(this.selectedMessageToReporterIndex === 0, this.selectedMessageToWriterIndex === 0);
    },
    onClickCancel: async function () {
      await this.onCancel();
    },
  },
};
</script>
<style lang="scss">
.footer {
  .footer-buttons {
    width: 100px;
  }
}
</style>
